import { inject } from "aurelia";
import { nhost } from '@lib/nhost';
import { IZeusClient, ZeusClient } from '@services/graphql-service/zeus-client';
import { GenericListComparsionType, GenericListFildInputType, IGenericListConfig } from '@components/generic-list/interfaces/generic-filtered-interface';
import { IDialogService } from "@aurelia/dialog";
import { IRouter } from "@aurelia/router";
import { CreateBrandComponent } from "../brand-guide/components/create-brand/create-brand-component";
import { FullScreenSpinnerDialog } from "@components/full-screen-spinner-dialog/full-screen-spinner-dialog";

@inject(IZeusClient, IRouter, IDialogService)
export class MediaPage {
  private selectedFiles: Blob[] | File = [];

  private brandId: string;
  private currentStep: number;

  constructor(private zeusClient: ZeusClient,
    private router: IRouter,
    private dialogService: IDialogService,
  ) { }

  private config: IGenericListConfig = {
    tableName: 'userMedia',
    streamName: 'userMedia_stream',
    aggregateName: 'userMedia_aggregate',
    columns: ['id', 'fileId', 'updated_at', 'deleted'],
    fixedFilters: [{
      comparsionType: GenericListComparsionType.Equals,
      title: 'deleted',
      field: 'deleted',
      type: GenericListFildInputType.Boolean,
      value: 'false',
    }],
    filters: [],
    data: [],
    total: 0,
    perPage: 9,
    currentPage: 1,
  }

  async attached() {
    const response = await this.zeusClient.chain('query')({
      brands: [
        { limit: 1 },
        {
          id: true,
          currentStep: true
        }
      ]
    })

    if (response?.brands?.length) {
      this.brandId = response?.brands[0]?.id as string;
      this.currentStep = response?.brands[0]?.currentStep;
    }
  }

  private async filesChanged(event: Event) {

    if (!event) return;

    if (this.selectedFiles) {

      const spinnerDialog = await this.dialogService.open({
        component: () => FullScreenSpinnerDialog,
        model: {},
        lock: true,
        startingZIndex: 100,
      });

      const fileResult = await nhost.storage.upload({
        file: this.selectedFiles[0],
        bucketId: 'public',
      })

      await this.zeusClient.chain('mutation')({
        insert_userMedia_one: [
          {
            object: {
              fileId: fileResult.fileMetadata.id,
            },
          },
          {
            id: true,
          },
        ]
      })
      spinnerDialog.dialog.ok()
    }
  }

  async downloadImage(fileId: string) {
    const fileReference = `https://uhgcmhbgmvuhtnaryxwr.storage.sa-east-1.nhost.run/v1/files/${fileId}?${new Date().getTime()}`;

    await this.downloadFile(fileReference)
  }

  async downloadFile(url: string) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'image.png';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  }

  async deleteUserMedia(userMediaId: string) {
    await this.zeusClient.chain('mutation')({
      update_userMedia_by_pk: [
        {
          pk_columns: {
            id: userMediaId,
          },
          _set: {
            deleted: true,
          },
        },
        {
          id: true,
        },
      ]
    })
  }

  private async createMedia() {

    if ((this.brandId && this.currentStep < 3) || !this.brandId) {
      await this.dialogService.open({
        component: () => CreateBrandComponent,
        model: {
        },
        lock: false,
        startingZIndex: 100,
      });

      return
    } else {
      this.router.load('image');
    }
  }

}